import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  popupAD: {
    isShow: false
  },
  appInstall: {
    isShow: false
  },
  mobileBottomAD: {
    isShow: false
  },
  fileMenu: {
    isShow: false
  }
};

const popupADSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    showPopupAD: (state) => ({
      ...state,
      popupAD: {
        isShow: true
      }
    }),
    hidePopupAD: (state) => ({
      ...state,
      popupAD: {
        isShow: false
      }
    }),
    showAppInstall: (state) => ({
      ...state,
      appInstall: {
        isShow: true
      }
    }),
    hideAppInstall: (state) => ({
      ...state,
      appInstall: {
        isShow: false
      }
    }),
    showMobileBottomAD: (state) => ({
      ...state,
      mobileBottomAD: {
        isShow: true
      }
    }),
    showFileMenu: (state) => ({
      ...state,
      fileMenu: {
        isShow: true
      }
    }),
    hideFileMenu: (state) => ({
      ...state,
      fileMenu: {
        isShow: false
      }
    })
  }
});

export const {
  showPopupAD,
  hidePopupAD,
  showAppInstall,
  hideAppInstall,
  showMobileBottomAD,
  showFileMenu,
  hideFileMenu
} = popupADSlice.actions;
export const usePopupSliceSelector = createSelectorFn(popupADSlice);
export default popupADSlice;
